"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import AppHead from "./components/AppHead.vue";
import ApplicationItem from "./components/ApplicationItem.vue";
let AppMain = class extends Vue {
  constructor() {
    super(...arguments);
    this.carousels = [];
    this.apps = [];
    this.carouselLoading = false;
    this.appsLoading = false;
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.checkAccount();
      this.getApps();
    });
  }
  checkAccount() {
    return __async(this, null, function* () {
    });
  }
  //获取轮播数据
  getCarousels() {
    return __async(this, null, function* () {
      try {
        this.carouselLoading = true;
        const response = yield API.get("api://base.apps.auth/v1/market/carousels");
        this.carousels = response.data.datas;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.carouselLoading = false;
      }
    });
  }
  getApps() {
    return __async(this, null, function* () {
      try {
        this.appsLoading = true;
        let _group = yield this.getAppsGroup();
        let _apps = [];
        if (_group) {
          for (const item of _group) {
            const response = yield API.get("api://base.apps.auth/v1/market/apps", {
              params: {
                group_name: item
              }
            });
            let _title = item;
            if (_title === "all") {
              _title = this.$t("appmain.all_applications");
            }
            _apps.push({
              title: _title,
              datas: response.data.datas
            });
          }
        }
        this.apps = _apps;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.appsLoading = false;
      }
    });
  }
  getAppsGroup() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get("api://base.apps.auth/v1/apps/groups");
        return response.data.datas;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  goDetail(id) {
    this.$router.push({ path: "/appdetail", query: { id } });
  }
  jump(url, isNew = false) {
    return __async(this, null, function* () {
      if (url === "" || url === null || url === void 0) {
        return;
      }
      if (isNew) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    });
  }
};
AppMain = __decorateClass([
  Component({
    components: {
      ApplicationItem,
      AppHead
    }
  })
], AppMain);
export {
  AppMain as default
};
